import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-570a0804"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-screen grid place-items-center dark:bg-slate-800 text-2xl px-4 overflow-hidden" }
const _hoisted_2 = { class: "text-center mt-8 font-inter" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-4xl text-secondary-500" }, "Test your focus", -1))
const _hoisted_4 = { class: "mt-4 dark:text-white text-lg" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" How fast can you spot the the ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" s? ")
const _hoisted_7 = { class: "h-[448px] relative" }
const _hoisted_8 = {
  key: 0,
  class: "w-80 pt-48 grid place-items-center mx-auto"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Start ")
const _hoisted_10 = {
  key: 1,
  class: "w-full"
}
const _hoisted_11 = { class: "mb-6 dark:text-white" }
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" You finished in ")
const _hoisted_14 = { class: "text-secondary-500 font-bold" }
const _hoisted_15 = {
  key: 0,
  class: "text-3xl mb-4 block"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "text-primary-500 font-bold" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-light text-base block" }, " Can you beat this time? ", -1))
const _hoisted_20 = { class: "dark:text-white mb-2" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Restart ")
const _hoisted_22 = { class: "flex justify-between items-center pt-8 mb-8" }
const _hoisted_23 = { class: "font-mono text-6xl dark:text-white h-16" }
const _hoisted_24 = {
  key: 0,
  class: "grid place-items-center h-80 dark:text-white"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "You took too long.", -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Try again ")
const _hoisted_27 = { class: "grid grid-cols-5 mt-6" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["max", "value"]

import { computed, ref, watch } from 'vue'
import { useTimer } from '@/useTimer'
import CustomTransition from '@/components/CustomTransition.vue'
import { fireworks, randomNumbers } from '@/helpers'

type AppState =
  | 'initialized'
  | 'countdown'
  | 'started'
  | 'completed'
  | 'abandoned'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

document.title = 'Focus'
const values = ref(randomNumbers())
const all = ref(
  Array.from({ length: 20 }, (_, i) => i + 1).map((i) => ({
    value: i,
    checked: false,
    correct: values.value.includes(i),
  }))
)
const correctRemaining = computed(
  () => all.value.filter((val) => !val.checked && val.correct).length
)
const totalCorrect = computed(() => values.value.length)

const {
  time,
  startTimer,
  stopTimer: stopTimer_,
  countdown,
  reset,
  stopped,
  bestTime,
  newRecord,
} = useTimer()

const restart = () => {
  reset()
  values.value = randomNumbers()
  all.value = Array.from({ length: 20 }, (_, i) => i + 1).map((i) => ({
    value: i,
    checked: false,
    correct: values.value.includes(i),
  }))

  startCountdown()
}

const stopTimer = (isAbandoned = false) => {
  stopTimer_(correctRemaining.value === 0)
  state.value = isAbandoned ? 'abandoned' : 'completed'
}

watch(correctRemaining, (val) => {
  if (val === 0) {
    stopTimer()
    if (newRecord.value) {
      fireworks()
    }
  }
})

const startCountdown = () => {
  state.value = 'countdown'
  countdown(5, () => {
    showCountdown.value = false
    state.value = 'started'
    startTimer()
  })
}

const showCountdown = ref<boolean | null>(null)
const state = ref<AppState>('initialized')

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_svg_icon, {
          name: "check",
          class: "inline"
        }),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(CustomTransition, {
          mode: "scale",
          speed: "fast"
        }, {
          default: _withCtx(() => [
            (['initialized', 'completed', 'abandoned'].includes(state.value))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (state.value === 'initialized')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "w-full h-16 rounded-full bg-secondary-500 text-white flex items-center justify-around",
                        onClick: startCountdown
                      }, [
                        _hoisted_9,
                        _createVNode(_component_svg_icon, { name: "play" })
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("div", _hoisted_11, [
                          _withDirectives(_createElementVNode("p", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(time).pretty), 1)
                          ], 512), [
                            [_vShow, !_unref(newRecord)]
                          ]),
                          _createElementVNode("p", null, [
                            _createVNode(CustomTransition, {
                              mode: "scale",
                              speed: "slow",
                              delay: ""
                            }, {
                              default: _withCtx(() => [
                                (_unref(newRecord))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, " New best time! "))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            (!_unref(newRecord))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Your best time is"))
                              : _createCommentVNode("", true),
                            _hoisted_17,
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(bestTime).pretty), 1)
                          ]),
                          _hoisted_19
                        ], 512), [
                          [_vShow, state.value === 'completed']
                        ]),
                        _withDirectives(_createElementVNode("p", _hoisted_20, " Try again? ", 512), [
                          [_vShow, state.value === 'abandoned']
                        ]),
                        _createElementVNode("button", {
                          class: "w-full h-16 rounded-full bg-secondary-500 text-white flex items-center justify-around",
                          onClick: restart
                        }, [
                          _hoisted_21,
                          _createVNode(_component_svg_icon, { name: "refresh" })
                        ])
                      ]))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(CustomTransition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_22, [
              _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(time).pretty), 1),
              _createVNode(CustomTransition, { horizontal: "" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("button", {
                    class: "dark:text-secondary-500",
                    onClick: stopTimer
                  }, " Give up ", 512), [
                    [_vShow, state.value === 'started']
                  ])
                ]),
                _: 1
              })
            ], 512), [
              [_vShow, ['started', 'countdown'].includes(state.value)]
            ])
          ]),
          _: 1
        }),
        _createVNode(CustomTransition, { multiple: "" }, {
          default: _withCtx(() => [
            (['countdown', 'started'].includes(state.value))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (state.value === 'started' && _unref(stopped))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("button", {
                          class: "w-full h-16 rounded-full bg-secondary-500 text-white flex items-center justify-around",
                          onClick: restart
                        }, [
                          _hoisted_26,
                          _createVNode(_component_svg_icon, { name: "refresh" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(all.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.value,
                        class: "p-2 h-16 w-16 border hover:bg-primary-light"
                      }, [
                        _createElementVNode("button", {
                          class: "rounded-full bg-primary w-full h-full grid place-items-center",
                          onClick: ($event: any) => (
                    state.value === 'started' && !_unref(stopped)
                      ? (item.checked = true)
                      : null
                  )
                        }, [
                          (item.checked || state.value === 'countdown')
                            ? (_openBlock(), _createBlock(_component_svg_icon, {
                                key: 0,
                                name: item.correct ? 'check' : 'x-icon',
                                class: _normalizeClass(["transition-opacity opacity-100", item.correct ? 'text-green-600' : 'text-red-600'])
                              }, null, 8, ["name", "class"]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_28)
                      ]))
                    }), 128))
                  ], 512), [
                    [_vShow, !_unref(stopped)]
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(CustomTransition, null, {
          default: _withCtx(() => [
            (state.value === 'started' && !_unref(stopped))
              ? (_openBlock(), _createElementBlock("progress", {
                  key: 0,
                  max: _unref(totalCorrect),
                  value: _unref(totalCorrect) - _unref(correctRemaining),
                  class: "w-full mt-6"
                }, null, 8, _hoisted_29))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})